
export default class Inspector {
  public firstName: string
  public lastName: string
  public signatureDataURL: string
  public SQUGDate?: Date

  constructor (firstName: string, lastName: string, signatureDataURL: string, SQUGDate?: Date) {
    this.firstName = firstName
    this.lastName = lastName
    this.signatureDataURL = signatureDataURL
    this.SQUGDate = SQUGDate
  }
}
